import CancelReasons from '../../../constants/cancel-reasons';
import useAxiosClient from '@blueshift-ui/fetch/dist/hooks/use-axios-client';
import useMutation from '@blueshift-ui/fetch/dist/hooks/use-mutation';

interface UseCancelSubscriptionParams {
  subscriptionId: string;
}

type UseCancelSubscriptionRequest = {
  cancelImmediately: boolean;
  cancelState: 'immediately' | 'end_of_billing_period' | 'end_of_contract';
  reasons: (typeof CancelReasons)[number][];
  sendEmailConfirmation: boolean;
};

function useCancelSubscription({ subscriptionId }: UseCancelSubscriptionParams) {
  const { makeMutation: makeRequestCancelSubscription, isLoading } = useMutation<
    UseCancelSubscriptionRequest,
    void
  >({
    mutationKey: 'cancel-subscription',
    mutationOptions: {
      meta: {
        client: useAxiosClient(),
      },
    },
    request: {
      method: 'POST',
      url: `/v1/subscriptions/${subscriptionId}/cancel`,
    },
  });

  return { makeRequestCancelSubscription, isLoading };
}

export default useCancelSubscription;
